import { ArrowRight } from "lucide-react";

import { Line } from "../../../Line";
import { Pressable } from "../../../Pressable";
import { Heading } from "../../../typography/Heading";
import { proposalImageClass } from "../styles";
import type { Proposal } from "../types";

export function ProposalCard({ proposal }: { proposal: Proposal }) {
    return (
        <div className="flex w-full flex-col items-start gap-12">
            <Pressable
                aria-label={proposal.title}
                href={proposal.href}
                className="w-full items-center justify-between gap-8 text-left"
            >
                <Heading level={5} className="normal-case! line-clamp-2">
                    {proposal.title}
                </Heading>

                <ArrowRight aria-hidden="true" className="size-24 shrink-0" />
            </Pressable>

            <Line variant="dashed" />

            <div className="flex w-full flex-col items-start gap-8">
                {proposal.bookings.map((booking) => (
                    <Pressable
                        key={booking.id}
                        href={booking.href}
                        className="w-full text-left"
                    >
                        <div className="flex w-full flex-row items-center gap-8">
                            <div className={proposalImageClass}>
                                {booking.imageUrl && (
                                    <img
                                        src={booking.imageUrl}
                                        alt={booking.title}
                                        className={proposalImageClass}
                                    />
                                )}
                            </div>

                            <Heading level={5}>{booking.title}</Heading>
                        </div>
                    </Pressable>
                ))}
            </div>
        </div>
    );
}
